<template>
  <el-card
class="card-container"
shadow="never">
    <el-row
slot="header"
type="flex"
justify="space-between"
align="middle">
      <h1 class="card-container__title">Thông tin chung</h1>
      <div>
        <el-button
          v-if="!isEdit"
          type="primary"
          size="small"
          icon="el-icon-edit"
          @click="() => (isEdit = true)"
        >
          Chỉnh sửa
        </el-button>
        <el-button
          v-if="isEdit"
          type="info"
          size="small"
          icon="el-icon-close"
          @click="() => handleCancel()"
        >
          Hủy
        </el-button>
        <el-button
          v-if="isEdit"
          type="primary"
          size="small"
          icon="el-icon-check"
          @click="() => handleSave()"
        >
          Lưu
        </el-button>
      </div>
    </el-row>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      :show-message="true"
      :disabled="!isEdit"
      size="small"
    >
      <el-row
        label-position="top"
        type="flex"
        align="start"
        class="flex-wrap"
        :gutter="12"
      >
        <el-col
:lg="4"
:md="8"
:span="24">
          <el-form-item
prop="key"
label="Mã đối tượng">
            <el-input
              v-model="form.key"
              :disabled="true"
              placeholder="Nhập thông tin"
            />
          </el-form-item>
        </el-col>
        <el-col
:lg="4"
:md="8"
:span="24">
          <el-form-item
prop="name"
label="Tên đối tượng">
            <el-input
v-model="form.name"
placeholder="Nhập thông tin" />
          </el-form-item>
        </el-col>
        <el-col
:lg="6"
:md="8"
:span="24">
          <el-form-item
prop="info.menu"
label="Tên menu hiển thị">
            <el-input
              v-model="form.info.menu"
              :disabled="false"
              placeholder="Nhập thông tin"
            />
          </el-form-item>
        </el-col>
        <el-col
:lg="6"
:md="8"
:span="24">
          <el-form-item
prop="info.icon"
label="Icon hiển thị">
            <el-input
              v-model="form.info.icon"
              :disabled="false"
              placeholder="Nhập thông tin"
            />
          </el-form-item>
        </el-col>
        <el-col
:lg="4"
:md="8"
:span="24">
          <el-form-item
prop="info.order"
label="STT đối tượng">
            <el-input-number
              v-model="form.info.order"
              class="w-100"
              placeholder="Nhập thông tin"
            />
          </el-form-item>
        </el-col>
        <el-col
:lg="12"
:md="12"
:span="24">
          <el-form-item
prop="header_actions"
label="Header buttons">
            <el-select
              v-model="form.header_actions"
              placeholder="Chọn buttons"
              class="w-100"
              multiple
            >
              <el-option
                v-for="op in headerActions"
                :key="op.key"
                :label="op.label"
                :value="op.key"
                :disabled="op.disabled"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
:lg="12"
:md="12"
:span="24">
          <el-form-item
prop="column_actions"
label="Table buttons">
            <el-select
              v-model="form.column_actions"
              placeholder="Chọn buttons"
              class="w-100"
              multiple
            >
              <el-option
                v-for="op in columnActions"
                :key="op.key"
                :label="op.label"
                :value="op.key"
                :disabled="op.disabled"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
:lg="12"
:md="12"
:span="24">
          <el-form-item
            v-if="object.type !== 'categories'"
            prop="relations"
            label="Đối tượng liên kết"
          >
            <el-select
              v-model="form.relations"
              placeholder="Chọn đối tượng"
              class="w-100"
              multiple
            >
              <el-option
                v-for="op in allConfigs.filter(c => c.type !== 'categories')"
                :key="op.id"
                :label="op.extra.name"
                :value="op.extra.key"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
v-if="objectSelectFields.length > 0"
:lg="12"
:md="12"
:span="24">
          <el-form-item
            prop="filter_default"
            label="Dữ liệu tìm kiếm mặc định"
          >
            <el-select
              v-model="form.filter_default"
              placeholder="Chọn trường dữ liệu"
              class="w-100"
            >
              <el-option
                v-for="f in objectSelectFields"
                :key="f.key"
                :label="f.name"
                :value="f.key"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>

<script>
import CONSTANTS from "@/config/constants.js";
import { notification } from "@/utils/common";

export default {
  name: "ConfigObjectInfo",
  props: {
    object: Object,
    allConfigs: Array
  },
  data() {
    return {
      headerActions: CONSTANTS.HEADER_ACTIONS,
      isEdit: false,
      callingAPI: false,
      isPublish: false,
      form: {
        key: "",
        name: "",
        header_actions: [],
        column_actions: [],
        relations: [],
        filter_default: '',
        info: {
          menu: "",
          icon: "",
          order: "",
        },
      },
    };
  },
  computed: {
    columnActions() {
      if (this.object.type === "categories") {
        return CONSTANTS.ALL_ACTIONS.filter((a) => ['edit', 'delete'].includes(a.key))
      }
      return CONSTANTS.ALL_ACTIONS.filter((a) => !a.hide);
    },
    rules() {
      return {
        name: [
          {
            required: true,
            message: "Tên đối tượng không được để trống",
            trigger: ["blur", "change"],
          },
        ],
        "info.menu": [
          {
            required: true,
            message: "Tên menu đối tượng không được để trống",
            trigger: ["blur", "change"],
          },
        ],
      };
    },
    objectSelectFields() {
      if (this.object) {
        return this.object.extra.fields.filter((f) => f.type === CONSTANTS.FIELD_TYPE.SELECT && !!f.options.type)
      }
      return []
    }
  },
  beforeMount() {
    this.handleInitData();
  },
  methods: {
    handleInitData() {
      this.form = {
        key: this.object ? this.object?.extra?.key : "",
        name: this.object ? this.object?.extra?.name : "",
        header_actions: this.object ? this.object?.extra?.header_actions : [],
        column_actions: this.object ? this.object?.extra?.column_actions : [],
        relations: this.object ? this.object?.extra?.relations : [],
        filter_default: this.object ? this.object?.extra?.filter_default : "",
        info: {
          menu: this.object ? this.object?.extra?.info?.menu : "",
          icon: this.object ? this.object?.extra?.info?.icon : "",
          order: this.object ? this.object?.extra?.info?.order : "",
        },
      };
    },
    handleCancel() {
      this.isEdit = false;
      this.$refs.form.resetFields();
      this.handleInitData();
    },
    handleSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit("save", {
            payload: this.form,
            success: () => {
              this.isEdit = false;
              notification(this, "success", "update", `thông tin chung`);
            },
            error: () => {
              notification(this, "success", "update", `thông tin chung`);
            },
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
